import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ResultsSection() {
  const results = ['Más control', 'Más seguridad', 'Más enfrentamientos ganados', 'Más rango', 'Más respeto dentro del juego'];
  return <section className="py-20 px-4 bg-[#0d0d0d] border-y border-white/5" data-id="element-196">
      <div className="max-w-4xl mx-auto text-center" data-id="element-197">
        <motion.h3 initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-orbitron text-white mb-12" data-id="element-198">
          En solo 7 días vas a notar:
        </motion.h3>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-199">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-2 bg-gamer-card px-6 py-3 rounded-full border border-gamer-red/20 shadow-lg shadow-gamer-red/5" data-id="element-200">
              <div className="bg-green-500/20 p-1 rounded-full" data-id="element-201">
                <Check className="w-4 h-4 text-green-500" data-id="element-202" />
              </div>
              <span className="text-white font-bold font-orbitron tracking-wide" data-id="element-203">
                {result}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}